import { createIcon } from '../createIcon';
import { ReactComponent as IconEllipsisV } from '../svg/ellipsis-v.svg';

export default createIcon(IconEllipsisV);
